import overallSummaryService from 'services/overall-summary-service'
import categoryAnalyticsService from 'services/category-analytics-service'

let LOAD_SALES_PERFORMANCE = 'LOAD_SALES_PERFORMANCE'
let LOAD_CATEGORY_ANALYTICS_DETAILS_COMPARISON = 'LOAD_CATEGORY_ANALYTICS_DETAILS_COMPARISON'

export function loadSalesPerformanceDetails(filter) {
  return (dispatch, getState) => {
    return overallSummaryService.getSalesDetails(filter)
      .then((salesDetails) => {
        dispatch({
          type: LOAD_SALES_PERFORMANCE,
          salesDetails: salesDetails
        })
      })
  }
}

export function loadCategoryAnalyticsWithComparison(filters, changesFrom) {
  return (dispatch, getState) => {
    return categoryAnalyticsService.getCategoryAnalyticsDetailsWithComparison(filters, changesFrom)
      .then((categoryAnalyticsDetailsComparison) => {
        dispatch({
          type: LOAD_CATEGORY_ANALYTICS_DETAILS_COMPARISON,
          categoryAnalyticsDetailsComparison: categoryAnalyticsDetailsComparison
        })
      })
  }
}

// ----
// Reducer
// ----

export function salesPerformanceDetailsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_SALES_PERFORMANCE: {
      return action.salesDetails
    }
    default:
      return state
  }
}

export function categoryAnalyticsWithComparisonReducer(state = [], action) {
  switch (action.type) {
    case LOAD_CATEGORY_ANALYTICS_DETAILS_COMPARISON : {
      return action.categoryAnalyticsDetailsComparison
    }
    default :
      return state
  }
}




// WEBPACK FOOTER //
// ./src/routes/OverallSummary/modules/OverallSummary.js